import type { Location } from "react-router-dom";

import {
  CARD_BOARD_URL_PATH,
  GRID_MULTI_SELECT_URL_PATH,
  GRID_SINGLE_SELECT_URL_PATH,
  KANBAN_URL_PATH,
  RIDES_CALENDAR_URL_PATH,
} from "@ryde/shared";

const RIDES_VIEW_PATHS = [
  CARD_BOARD_URL_PATH,
  KANBAN_URL_PATH,
  GRID_MULTI_SELECT_URL_PATH,
  GRID_SINGLE_SELECT_URL_PATH,
  RIDES_CALENDAR_URL_PATH,
] as const;

export const getRidesViewSwitchKey = (pathname: string): string => {
  const match = RIDES_VIEW_PATHS.find(path => pathname.includes(path));
  return match ?? "rides-view";
};

export const resolveRidesViewRoutesLocation = ({
  liveLocation,
  frozenLocation,
  paneViewKey,
}: {
  liveLocation: Location;
  frozenLocation: Location;
  paneViewKey: string;
}): Location => {
  if (getRidesViewSwitchKey(liveLocation.pathname) === paneViewKey) {
    return liveLocation;
  }
  return frozenLocation;
};
